<template>
    <v-dialog v-model="active" fullscreen hide-overlay transition="dialog-bottom-transition" style="overflow: hidden"
        class="timeline-dialog">
        <v-card class="d-flex flex-column">
            <v-card-title class="pa-0" style="position: sticky; top: 0; z-index: 99">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        <p class="mb-0">{{ title }}</p>
                        <p class="mb-0 subtitle-2" v-if="subtitle">{{ subtitle }}</p>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="closeModal()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
            </v-card-title>
            <v-card-text>
                <slot />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "BaseFullscreenModal",
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
        }
    },
    emits: ['closeModal'],
    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
    }
}
</script>

<style>
.timeline-dialog .v-dialog--fullscreen {
    overflow-x: hidden;
}

.v-dialog--fullscreen {
    overflow-x: hidden;
}
</style>